//export const API_BASE_URL = "https://api.mudamukuafor.com";
//export const API_BASE_URL = "http://127.0.0.1:8000";
export const API_BASE_URL = "https://api.ahmettosunluxury.com";


// --- UYGULAMA VE MARKA AYARLARI ---
export const BUSINESS_NAME = "Ahmet Tosun Luxury";
export const COMPANY_NAME = "Vireliosoft / RandevUpp";

export const COMPANY_MOTTO = "";



export const COMPANY_MOTTO_HEADER = "";

export const FASTBOOKING_TEXT_TOP = "Ahmet Tosun Luxury";

export const FASTBOOKING_TEXT_TOP_UNDER = "2.0"

export const FASTBOOKING_TEXT_GENERAL_1 = "Tarzınızı Keşfedin"

export const FASTBOOKING_FOOTER = "Ahmet Tosun Luxury"